import React from 'react';
import { string } from 'prop-types';
import classNames from 'classnames';
import css from './OrderPanelSkeleton.module.css';

const OrderPanelSkeleton = ({ className, rootClassName }) => {
    const classes = classNames(rootClassName || css.root, className);

    return (
        <div className={classes}>
            <div className={css.topBorder}>
                <div className={css.topBorderContent}>
                    {/* Modal heading for mobile */}
                    <div className={css.modalHeading}>
                        <div className={classNames(css.skeleton, css.skeletonTitle)} />
                    </div>

                    {/* Desktop heading */}
                    <div className={css.orderHeading}>
                        <div className={classNames(css.skeleton, css.skeletonTitle)} />
                    </div>

                    {/* Price and packages section */}
                    <div className={css.priceAndPackages}>
                        <div className={classNames(css.skeleton, css.skeletonPrice)} />
                        <div className={classNames(css.skeleton, css.skeletonPerUnit)} />

                        {/* Package options skeleton */}
                        <div className={css.packagesContainer}>
                            <div className={classNames(css.skeleton, css.skeletonPackage)} />
                            <div className={classNames(css.skeleton, css.skeletonPackage)} />
                            <div className={classNames(css.skeleton, css.skeletonPackage)} />
                        </div>
                    </div>
                </div>

                {/* Form section skeleton */}
                <div className={css.formSection}>
                    {/* Date inputs */}
                    <div className={css.dateInputsRow}>
                        <div className={classNames(css.skeleton, css.skeletonInput)} />
                        <div className={classNames(css.skeleton, css.skeletonInput)} />
                    </div>

                    {/* Additional form fields */}
                    <div className={css.formFieldsContainer}>
                        <div className={classNames(css.skeleton, css.skeletonField)} />
                        <div className={classNames(css.skeleton, css.skeletonField)} />
                    </div>

                    {/* Breakdown section */}
                    <div className={css.breakdownSection}>
                        <div className={classNames(css.skeleton, css.skeletonBreakdownTitle)} />
                        <div className={css.breakdownLines}>
                            <div className={classNames(css.skeleton, css.skeletonBreakdownLine)} />
                            <div className={classNames(css.skeleton, css.skeletonBreakdownLine)} />
                            <div className={classNames(css.skeleton, css.skeletonBreakdownLine)} />
                        </div>
                        <div className={classNames(css.skeleton, css.skeletonTotal)} />
                    </div>

                    {/* Author details section */}
                    <div className={css.authorSection}>
                        <div className={css.authorHeader}>
                            <div className={classNames(css.skeleton, css.skeletonAvatar)} />
                            <div className={css.authorInfo}>
                                <div className={classNames(css.skeleton, css.skeletonAuthorName)} />
                                <div className={classNames(css.skeleton, css.skeletonAuthorMeta)} />
                            </div>
                        </div>
                        <div className={classNames(css.skeleton, css.skeletonMessageButton)} />
                    </div>
                </div>
            </div>

            {/* Mobile bottom navbar */}
            <div className={css.openOrderFormContainer}>
                <div className={css.openOrderForm}>
                    <div className={classNames(css.skeleton, css.skeletonButton)} />
                    <div className={classNames(css.skeleton, css.skeletonButton)} />
                </div>
            </div>
        </div>
    );
};

OrderPanelSkeleton.defaultProps = {
    rootClassName: null,
    className: null,
};

OrderPanelSkeleton.propTypes = {
    rootClassName: string,
    className: string,
};

export default OrderPanelSkeleton;

